/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamDropdown200,
  GetApiV1ExamDropdown401,
  GetApiV1ExamDropdown500,
  GetApiV1ExamDropdownQueryParams,
  GetApiV1ExamDropdownQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ExamDropdownQueryParamsSchema = z.object({
  title: z.optional(z.string()),
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1ExamDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDropdown500>;

export const getApiV1ExamDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ExamDropdown200Schema,
) as unknown as ToZod<GetApiV1ExamDropdownQueryResponse>;
